<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><em class="italic">Prologue</em><span class="smallcaps"><br/></span>THE FOUNDATIONS</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// theviennamelody_00001.vue?5e83ba7a